import { SupportedLocale } from '@amzn/aapn-stage-dive-shared-types'

export const getDateTimeFormat = (rawDate: Date, language: SupportedLocale): string => {
  const formattedLastSavedDate = rawDate.toLocaleString(language, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
  const formattedLastSavedTime = rawDate.toLocaleTimeString(language, {
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  })
  return `${formattedLastSavedDate} ${formattedLastSavedTime}`
}
